import type { QuestionResult } from '../hooks/useQuizSession'
import type { Stage } from '../components/ui'
import type { MasteryLevel } from '../types/models'

export const STAGE: Record<MasteryLevel, Stage> = { SEED: 0, SPROUT: 1, SAPLING: 2, FOREST: 3 }

export function didGrow(r: QuestionResult): boolean {
  const after = r.afterStage ?? r.beforeStage
  return STAGE[after] > STAGE[r.beforeStage]
}

export function heroStage(results: QuestionResult[]): Stage {
  if (results.length === 0) return STAGE.SPROUT
  return results.reduce<Stage>((max, r) => Math.max(max, STAGE[r.afterStage ?? r.beforeStage]) as Stage, STAGE.SEED)
}

export function nextReviewLabel(days: number): string {
  if (days <= 0) return 'Next review today'
  if (days === 1) return 'Next review in 1d'
  return `Next review in ${days}d`
}

export function overallNextReviewLabel(hours: number | null, dailyGoalMet: boolean): string {
  if (hours == null) return 'scheduled'
  if (hours < 1) return dailyGoalMet ? 'tomorrow' : 'now'
  if (hours < 24) return 'today'
  if (hours < 48) return 'tomorrow'
  return `in ${Math.floor(hours / 24)} days`
}
